import { DropdownBase } from "@/components/General/Dropdown/components/base";
import { Caret } from "@/components/General/Dropdown/components/caret";
import { Divider } from "@/components/General/Dropdown/components/divider";
import { Header } from "@/components/General/Dropdown/components/header";
import { Item } from "@/components/General/Dropdown/components/item";
import { Label } from "@/components/General/Dropdown/components/label";
import { Menu } from "@/components/General/Dropdown/components/menu";
import { Toggle } from "@/components/General/Dropdown/components/toggle";

export const Dropdown = Object.assign(DropdownBase, {
    Divider: Divider,
    Header: Header,
    Caret: Caret,
    Item: Item,
    Menu: Menu,
    Toggle: Toggle,
    Label: Label
});
